import React from 'react';

import Header from '../../components/user/header/Header.jsx';
import SubIntro from '../../components/user/sub_intro1/Intro.jsx';
import Content from '../../components/user/sub3_2/Content.jsx';
import Footer from '../../components/user/footer/Footer.jsx';

import '../../styles/user/common.css';
import '../../styles/user/default.css';
import '../../styles/user/fixed.css';
import '../../styles/user/font.css';
import '../../styles/user/footer.css';
import '../../styles/user/header.css';
import '../../styles/user/main.css';
import '../../styles/user/slick-theme.css';
import '../../styles/user/slick.css';
import '../../styles/user/sub.css';

export default function Sub3_2() {
  const introData = {
    mainTitle: ' 이벤트/소식',
    subTitle: '크림봇의 다양한 이벤트 및 소식을 확인해보세요',
    menuItems: [
      { title: '크림봇 EVENT', link: '/sub3_1', active:false  },
      { title: '뉴스/소식', link: '/sub3_2', active: true }
    ],
  };

  return (
    <>
      <Header />
      <SubIntro
        mainTitle={introData.mainTitle}
        subTitle={introData.subTitle}
        menuItems={introData.menuItems}
      />
      <Content />
      <Footer />
    </>
  );
}
